"use strict";

var _regeneratorRuntime = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStorageNodeRegistryFromContract = exports.createStorageNodeRegistry = exports.StorageNodeRegistry = void 0;

var ethers_1 = require("ethers");

var storageNodeRegistryConfig = __importStar(require("../../contracts/NodeRegistry.json"));

var JsonRpcProvider = ethers_1.providers.JsonRpcProvider;

var StorageNodeRegistry = /*#__PURE__*/function () {
  function StorageNodeRegistry(records) {
    _classCallCheck(this, StorageNodeRegistry);

    this.records = records;
  }

  _createClass(StorageNodeRegistry, [{
    key: "getStorageNodeHTTP",
    value: function getStorageNodeHTTP(address) {
      var found = this.records.find(function (p) {
        return p.address === address;
      });

      if (found) {
        return found.url;
      } else {
        throw new Error("Storage node with address (".concat(address, ") not found in registry"));
      }
    }
  }, {
    key: "getAllStorageNodes",
    value: function getAllStorageNodes() {
      return this.records;
    }
  }]);

  return StorageNodeRegistry;
}();

exports.StorageNodeRegistry = StorageNodeRegistry;

function fetchStorageNodes(_x, _x2) {
  return _fetchStorageNodes.apply(this, arguments);
}

function _fetchStorageNodes() {
  _fetchStorageNodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(contractAddress, jsonRpcProvider) {
    var provider, contract, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = new JsonRpcProvider(jsonRpcProvider); // check that provider is connected and has some valid blockNumber

            _context.next = 3;
            return provider.getBlockNumber();

          case 3:
            contract = new ethers_1.Contract(contractAddress, storageNodeRegistryConfig.abi, provider); // check that contract is connected

            _context.next = 6;
            return contract.addressPromise;

          case 6:
            if (!(typeof contract.getNodes !== 'function')) {
              _context.next = 8;
              break;
            }

            throw Error("getNodes function is not defined in smart contract (".concat(contractAddress, ")"));

          case 8:
            _context.next = 10;
            return contract.getNodes();

          case 10:
            result = _context.sent;
            return _context.abrupt("return", result.map(function (node) {
              return {
                address: node.nodeAddress,
                url: JSON.parse(node.metadata).http
              };
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchStorageNodes.apply(this, arguments);
}

function createStorageNodeRegistry(servers) {
  return new StorageNodeRegistry(servers);
}

exports.createStorageNodeRegistry = createStorageNodeRegistry;

function getStorageNodeRegistryFromContract(_x3) {
  return _getStorageNodeRegistryFromContract.apply(this, arguments);
}

function _getStorageNodeRegistryFromContract() {
  _getStorageNodeRegistryFromContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var contractAddress, jsonRpcProvider, storageNodes;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            contractAddress = _ref.contractAddress, jsonRpcProvider = _ref.jsonRpcProvider;
            _context2.next = 3;
            return fetchStorageNodes(contractAddress, jsonRpcProvider);

          case 3:
            storageNodes = _context2.sent;
            return _context2.abrupt("return", createStorageNodeRegistry(storageNodes));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getStorageNodeRegistryFromContract.apply(this, arguments);
}

exports.getStorageNodeRegistryFromContract = getStorageNodeRegistryFromContract;